var Keyboard = require('../lib/keyboard.es6').default;


var HistoryCompletion = Backbone.View.extend({
    initialize: function (options) {
        this.input = options.input;

        this.currentValue = {msg: ''};

        this.index = 0;

        this.model.bind('sayRequest', this.sayRequest, this);
        this.model.bind('removePending', this.removePending, this);
        this.model.bind('removeAllPending', this.removePending, this);
    },
    events: {
        'keydown': 'keyDown'
    },
    sayRequest: function (message, reqid) {
        this.resetIndex();
        this.pending = true;
    },
    removePending: function () {
        this.pending = false;
    },
    pushState: function (message, reply) {
        this.model.pushInputHistory(message, reply);
    },
    isIndexReset: function () {
        // Can be 0 or undefined
        return !this.index;
    },
    incrementIndex: function (value) {
        this.index += value;
    },
    resetIndex: function () {
        this.index = 0;
    },
    getFromEnd: function (index) {
        return this.model.inputHistory[this.getLength() + this.index + index];
    },
    getLength: function () {
        return this.model.inputHistory.length;
    },
    getEarlier: function () {
        var value = this.getFromEnd(-1);
        if (value !== undefined) {
            // Move index up
            this.incrementIndex(-1);
        }
        return value;
    },
    getLater: function () {
        // Invalid if called from the bottom of the index
        if (this.isIndexReset()) {
            return undefined;
        }
        var value = this.getFromEnd(1);
        if (value !== undefined) {
            // Move index down
            this.incrementIndex(1);
        } else {
            // We've moved to the end, reset the index to the end
            this.resetIndex();
        }
        return value;
    },
    setVal: function (value) {
        this.input.setVal(value.msg);
        if (value.reply) {
            this.model.trigger('lockReplyHighlight', value.reply);
        } else {
            this.model.trigger('clearReplyHighlight');
        }
    },
    keyDown: function (e) {
        if (e.metaKey || e.altKey || e.shiftKey) {
            // Ignore modifier keys
            return true;
        }

        // TODO reverse behaviour setting
        if (e.ctrlKey) {
            if (e.which === Keyboard.KEYS.UP) {
                var editMessage = this.model.getLastEditableMessage();
                if (editMessage) {
                    if (!this.pending) {
                        this.model.trigger('editMessagePrompt', editMessage);
                    }
                    return false;
                }
            }
            return true;
        }

        var value;
        if (e.which === Keyboard.KEYS.UP) {
            // Store the input value before we go galloping off into the history
            if (this.isIndexReset()) {
                this.currentValue = {
                    msg: this.input.val(),
                    reply: this.input.replyTarget
                };
                if (this.currentValue.msg.indexOf('\n') !== -1) {
                    // abort if there's a new line in the current text
                    return true;
                }
                if (this.input.autogrow && this.input.autogrow.isGrown()) {
                    // abort if the input is wrapping to multiple lines
                    return true;
                }
            }
            value = this.getEarlier();
            if (value !== undefined) {
                this.setVal(value);
            }
            return false;
        } else if (e.which === Keyboard.KEYS.DOWN) {
            if (this.isIndexReset()) {
                // We're at the bottom
                if (this.input.autogrow && this.input.autogrow.isGrown()) {
                    // abort if the input is wrapping to multiple lines
                    return true;
                }
                // push any current text onto the buffer and reset
                var val = this.input.val();
                if (val) {
                    this.pushState(val, this.input.replyTarget);
                    this.setVal({msg: ''});
                    return true;
                }
                return false;
            }
            value = this.getLater();
            if (value !== undefined) {
                this.setVal(value);
            } else {
                // Reset the input value to it's previous value
                this.setVal(this.currentValue);
            }
            return false;
        } else {
            // Any other key preses resets the index to the end
            this.resetIndex();
        }
        return true;
    }
});


module.exports = HistoryCompletion;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/historycompletion.js
// module id = J6S1
// module chunks = 1